<template>
  <div>
    <div class="medical-report-login">
      <div class="medical-report-login-logo">
        <img :src="require('@assets/report_ly_logo.png')" alt="" />
      </div>
      <div class="medical-report-login-lable">自助领取，省时省力</div>
      <van-form @submit="onSubmit" class="medical-report-login-form">
        <van-field
          v-model="reportNo"
          :center="true"
          placeholder="请输入您的体检号"
        />
        <ph-button
          class="medical-report-login-commit-button"
          title="查询报告"
          native-type="submit"
        />
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      telphone: "",
      verifyCode: "",
      reportNo: "",
      phoneCode: "",
      verifyCodeId: "",
      verifyCodeImage: "",
      countDownTime: 0,
      timer: null,
      mesToken: "",
      list: [],
      showLogin: false,
      showList: true
    };
  },
  created() {
    // this.getReportList();
  },
  methods: {
    getReportList() {
      // this.mesToken = localStorage.getItem("mesToken");
      // if (this.mesToken) {
      // }
      // else {
      //   this.list = [];
      //   this.showList = true;
      //   this.showLogin = false;
      //   // this.getVerifyCode();
      // }
    },
    getVerifyCode() {
      this.$http.post(this.$api.USER_VERIFY_CODE, {}).then(res => {
        this.verifyCodeId = res.picId;
        this.verifyCodeImage = res.url;
      });
    },
    sendCode() {
      if (!this.telphone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.verifyCode) {
        this.$toast("请输入图形验证码");
        return;
      }
      if (!this.name) {
        this.$toast("请输入您的姓名");
        return;
      }
      this.$http
        .post(this.$api.REST_MES_SENDSMS, {
          picId: this.verifyCodeId,
          picCode: this.verifyCode,
          phone: this.telphone,
          name: this.name
        })
        .then(() => {
          this.$toast("发送成功");
          this.startCountDown();
        });
    },
    routeTo(item) {
      window.location.href = item.reportUrl;
      // window.location.href =
      //   "/pdf/web/viewer.html?file=" + encodeURIComponent(item.reportUrl);
    },
    onSubmit() {
      if (!this.reportNo) {
        this.$toast("请输入您的体检单号");
        return;
      }
      this.$router.push({
        name: "medical-report-list",
        query: {
          reportNo: this.reportNo
        }
      });
      // this.getReportList();
    },
    routeToLoign() {
      this.showLogin = true;
      this.showList = false;
      this.getVerifyCode();
    },
    startCountDown() {
      clearInterval(this.timer);
      this.timer = null;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="less">
.medical-report-top {
  display: flex;
  align-items: center;
  height: 2.5rem;
  color: white;
  text-align: right;
  background-color: rgb(63, 100, 232);
  img {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0.5rem;
  }
}
.medical-report-list {
  margin: 1rem 1rem 0 1rem;
  border-radius: 0.2rem;
  &-content {
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    color: rgb(153, 153, 153);
    font-weight: bold;
    background-color: rgb(240, 247, 254);
    &-lable {
      padding: 0.5rem 0.5rem 0 1rem;
      span {
        margin-left: 1rem;
        color: black;
        font-weight: normal;
      }
    }
    &-btn {
      margin: 1rem 3rem 0 3rem;
      color: #fff;
      font-weight: normal;
      line-height: 2rem;
      text-align: center;
      background-color: rgb(127, 117, 247);
      border-radius: 4px;
    }
  }
  &-top {
    display: flex;
    height: 2.5rem;
    color: white;
    line-height: 2.5rem;
    background-color: rgb(63, 100, 232);
    &-logo {
      width: 2rem;
      height: 2rem;
      margin: 0.25rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &-time {
      margin-right: 0.2rem;
      margin-left: auto;
    }
  }
}
.medical-report-login {
  background-color: white;
  &-lable {
    margin-top: 2.66rem;
    font-weight: bold;
    font-size: 1.56rem;
    text-align: center;
  }
  &-logo {
    width: 6.25rem;
    height: 6.25rem;
    margin: 4.96rem auto 1rem auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-form {
    margin-top: 1.75rem;
    padding: 0.8rem;
    background: white;

    .van-cell {
      padding: 0.6rem 0;
      border-bottom: 1px solid @primary-gray;
      input::-webkit-input-placeholder {
        color: gray;
      }
    }

    .van-cell::after {
      position: relative;
    }

    .van-field__body {
      font-size: 0.94rem;
    }
    .van-field {
      width: 70%;
      margin: 0 15%;
      border: 1px solid #dadada;
    }
    .van-field__control {
      text-align: center;
    }
  }

  &-send-verifycode {
    font-size: 0.8rem;
    line-height: 1.5rem;
  }

  &-commit-button {
    width: 100%;
    margin: 2.56rem 0 0 0;
    line-height: 2.5rem;
  }

  &-tips {
    margin: 1rem 0.4rem;
    color: red;
    font-size: 0.8rem;
    div {
      color: gray;
    }
  }
}
</style>
